import axios from '../axios'
import qs from 'qs';

/* 
 * 系统登录模块
 */

// 登录
export const login = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/kz/user/login',
		method: 'post',
		data
	})
}
// 登出
export const logout = () => {
	return axios({
		url: '/kz/user/logout',
		method: 'post'
	})
}
// 获取用户信息，获取导航树
export const getNavByRole = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/kz/menu/nav',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js